import { render, staticRenderFns } from "./teams-dropdown.vue?vue&type=template&id=2ed9205d"
import script from "./teams-dropdown.vue?vue&type=script&lang=js"
export * from "./teams-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports